import { combineReducers } from 'redux';

import tots from './tots';
import dataInici from './dataInici';
import dataFi from './dataFi';
import peticioObservacionsEnCurs from './peticioObservacionsEnCurs';
import estacioSeleccionada from './estacioSeleccionada';


export default combineReducers({
    tots,
    dataInici,
    dataFi,
    peticioObservacionsEnCurs,
    estacioSeleccionada
});



// WEBPACK FOOTER //
// ./src/reducers/observacio/exportacio/index.js